<template>
<div class="container-fluid">
  <div class="row">
    <div style="text-align: center" class="col-md-12">
      <template v-if="showSuccess">
        <div class="row justify-content-md-center">
          <div class="col-md-12">
            <b-alert variant="success" show>Thank you for your feedback!</b-alert>
          </div>
        </div>
      </template>
      <h1>Feedback</h1>
      <p>Tell us how we can improve the site and any other features you'd like to see</p>
      <div class="col-md-6 offset-md-3">
      <b-form-textarea :rows="3" v-model="feedback" type="text" placeholder="Enter feedback here" />
      <button style="margin-top: 50px;" class="btn btn-primary" @click="submitFeedback">Submit</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { db } from '@/main';
import firebase from 'firebase';

export default {
  data() {
    return {
      feedback: '',
      showSuccess: false,
    }
  },
  methods: {
    submitFeedback() {
      if (this.feedback === '') {
        return;
      }
      db.collection('feedback').add({
        feedback: this.feedback,
        userId: firebase.auth().currentUser.uid,
      }).then(() => {
        this.showSuccess = true;
        this.feedback = ""
      });
    }
  }
}
</script>
